import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`font-heading text-xl font-semibold whitespace-nowrap cursor-pointer transition-colors duration-300 ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-white'
            }`}
          >
            {t('common.siteTitle')}
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-300 ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-600'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              {t('common.navHome')}
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-300 ${
                  scrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-600'
                    : 'text-white/80 hover:text-white'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-300 ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-600'
                  : 'text-white/80 hover:text-white'
              }`}
            >
              {t('common.navAbout')}
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors duration-300 ${
              scrolled || !isHome ? 'text-foreground-800' : 'text-white'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 py-4 px-2 flex flex-col gap-3 animate-in">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-600 px-3 py-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer">{t('common.navHome')}</Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="text-sm font-medium text-foreground-700 hover:text-primary-600 px-3 py-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer">{cat.name}</Link>
            ))}
            <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-600 px-3 py-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer">{t('common.navAbout')}</Link>
          </div>
        )}
      </div>
    </nav>
  );
}